import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { sendToVercelAnalytics } from "./vitals";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme";

// Prevent dragging of all images across the app
if (
  typeof document !== "undefined" &&
  !document.body.hasAttribute("data-img-drag-block")
) {
  document.body.setAttribute("data-img-drag-block", "true");
  document.addEventListener("dragstart", (e) => {
    const target = e.target as HTMLElement | null;
    if (target && target.tagName === "IMG") {
      e.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(sendToVercelAnalytics);
